import { Inject, Injectable, PLATFORM_ID, Signal, signal, WritableSignal } from '@angular/core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Platform } from '@angular/cdk/platform';

import { Constants } from '@helper/constants';
import { LegacyRouteHelper } from '../ui/legacy/helper/legacy-route-paths';
import { AppHelper } from '@helper/app-helper';

import { Subject } from 'rxjs';
import { DeviceDetectorService } from 'ngx-device-detector';

@Injectable({
  providedIn: 'root',
})
export class WindowDetectService {
  get isMobileDevice(): Signal<boolean> {
    return this._isMobileDevice;
  }

  get isTablet(): Signal<boolean> {
    return this._isTablet;
  }

  get isLegacyWebsite(): Signal<boolean> {
    return this._isLegacyWebsite;
  }

  get isWebsiteForApp(): Signal<boolean> {
    return this._isWebsiteForApp;
  }

  get isShortUrlWebsite(): Signal<boolean> {
    return this._isShortUrlWebsite;
  }

  get isPreviewWebsite(): Signal<boolean> {
    return this._isPreviewWebsite;
  }

  readonly loadMore = new Subject<boolean>();
  readonly windowWidth = signal(Constants.APP_MOBILE_CONTAINER_WIDTH);
  readonly windowHeight = signal(Constants.APP_MOBILE_CONTAINER_HEIGHT);
  readonly currentPath = signal('');
  readonly isFb = signal(false);
  readonly isWechat = signal(false);
  readonly beforeLoadedScrollY = signal(0);

  private readonly _isMobileDevice: WritableSignal<boolean>;
  private readonly _isTablet: WritableSignal<boolean>;
  private readonly _isLegacyWebsite: WritableSignal<boolean>;
  private readonly _isWebsiteForApp: WritableSignal<boolean>;
  private readonly _isShortUrlWebsite: WritableSignal<boolean>;
  private readonly _isPreviewWebsite: WritableSignal<boolean>;
  private readonly isBrowser = isPlatformBrowser(this.platformId);

  constructor(
    private device: DeviceDetectorService,
    @Inject(PLATFORM_ID) private platformId: object,
    platform: Platform,
    @Inject(DOCUMENT) document: Document
  ) {
    this._isMobileDevice = signal(!device.isDesktop());
    this._isTablet = signal(device.isTablet());
    this._isLegacyWebsite = signal(document.location.hostname.includes(LegacyRouteHelper.legacy));
    this._isWebsiteForApp = signal(document.location.hostname.startsWith('store.'));
    this._isShortUrlWebsite = signal(document.location.hostname.includes('lativ.tw'));
    this._isPreviewWebsite = signal(document.location.hostname.startsWith('preview.'));
    if (this.isBrowser) {
      this.isFb.set(AppHelper.isFBAgent());
      this.isWechat.set(AppHelper.isWechat());
      if (AppHelper.isIPad() || AppHelper.isAndroidPad(platform)) {
        this._isMobileDevice.set(true);
        this._isTablet.set(true);
      }
    }
  }

  detectWindowHeight(): void {
    if (this.isBrowser) {
      this.windowHeight.set(window.innerHeight);
    } else {
      this.windowHeight.set(
        this.device.isTablet() ? Constants.APP_TABLET_CONTAINER_HEIGHT : Constants.APP_MOBILE_CONTAINER_HEIGHT
      );
    }
  }

  detectWindowWidth(): void {
    if (this.isBrowser) {
      this.windowWidth.set(this.isMobileDevice() ? window.innerWidth : Constants.APP_CONTAINER_WIDTH);
    } else {
      if (this.device.isDesktop()) {
        this.windowWidth.set(Constants.APP_CONTAINER_WIDTH);
      } else if (this.device.isTablet()) {
        this.windowWidth.set(Constants.APP_TABLET_CONTAINER_WIDTH);
      } else {
        this.windowWidth.set(Constants.APP_MOBILE_CONTAINER_WIDTH);
      }
    }
  }
}
